import { AvailabilityzoneUrl } from "./live-feed-preview";
import { WebRTCPreview } from "./web-r-t-c-preview";

export class ChannelFuturePreview extends WebRTCPreview {
  constructor(
    public id: string,
    clientId: string,
    brodcasterId: string,
    availabilityZoneUrls: {
      [id: string]: AvailabilityzoneUrl;
    },
    tcpOnlyWebRTC = false,
  ) {
    super(
      clientId,
      brodcasterId,
      [availabilityZoneUrls[Object.keys(availabilityZoneUrls)[0]].url],
      tcpOnlyWebRTC,
    );
  }
}
